var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"documents-page"},[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"documents-layout"},[_c('div',{staticClass:"documents-sidebar"},[_c('file-tree')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }